import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'functionBoolean',
})
export class FunctionBooleanPipe<T> implements PipeTransform {
  transform(
    element: T,
    booleanCallBackFunction: ((element, ...args) => boolean) | boolean,
    ...args
  ): boolean | T {
    if (
      (booleanCallBackFunction !== null ||
        booleanCallBackFunction !== undefined) &&
      typeof booleanCallBackFunction == 'function'
    ) {
      return booleanCallBackFunction(element, ...args);
    } else if (
      (booleanCallBackFunction !== null ||
        booleanCallBackFunction !== undefined) &&
      typeof booleanCallBackFunction == 'boolean'
    ) {
      return booleanCallBackFunction;
    } else {
      return element;
    }
  }
}
